var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ref } from 'vue';
import client from '@/client/index';
export function useRemoveResource(target, init) {
    if (init === void 0) { init = {}; }
    var removing = ref(false);
    var resource = ref(__assign({}, init));
    var errors = ref({});
    var message = ref('');
    var remove = function (callback) {
        removing.value = true;
        client.delete(target.value, { data: resource.value })
            .then(function (result) {
            removing.value = false;
            message.value = "";
            errors.value = {};
            callback();
        })
            .catch(function (error) {
            var _a, _b, _c, _d, _e, _f;
            removing.value = false;
            message.value = (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "";
            errors.value = (_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) !== null && _f !== void 0 ? _f : {};
        });
    };
    return { remove: remove, removing: removing, resource: resource, errors: errors, message: message };
}
;
